import { bootstrapApplication } from '@angular/platform-browser';
import * as LogRocket from 'logrocket';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';

if (environment.production && environment.logRocketKey) {
  LogRocket.init(environment.logRocketKey, {
    console: {
      shouldAggregateConsoleErrors: true,
    },
  });
}

bootstrapApplication(AppComponent, appConfig).catch((err) =>
  // eslint-disable-next-line no-console
  console.error(err)
);
